// import { IUsuario } from "../interfaces/IUsuario";

import { IRealizarLoginDTO } from "@/services/AcessoService";

// import { any, any } from "../interfaces/responses/IAutenticacao";

export default class StorageUtils {
    static async clearStorage() {
        localStorage.removeItem("lojacap:usuario");
    }

    static async getUsuario(): Promise<IRealizarLoginDTO | undefined> {
        const usuarioJson = localStorage.getItem("lojacap:usuario");

        if (usuarioJson === null) {
            return;
        }

        const user = JSON.parse(usuarioJson);

        return user as IRealizarLoginDTO;
    }

    static setUsuario(usuario: any): void {
        localStorage.setItem("lojacap:usuario", JSON.stringify(usuario));
    }

    static setIdVendedor(idVendedor: string): void {
        localStorage.setItem("lojacap:idVendedor", idVendedor);
    }

    static getIdVendedor() {
        const idVendedor = localStorage.getItem("lojacap:idVendedor")
        if (!idVendedor) {
            return undefined;
        }

        return Number(idVendedor);;
    }

    static removeIdVendedor() {
        return localStorage.removeItem('lojacap:idVendedor')
    }


    static async getDispositivo(): Promise<string> {
        let dispositivo = localStorage.getItem("lojacap:dispositivo");

        if (dispositivo === null) {
            dispositivo = Math.random().toString(36).substring(2);
            localStorage.setItem("lojacap:dispositivo", dispositivo)
            return dispositivo
        }

        return dispositivo;
    }
}